import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    inputStyle: {
        " & input": {
            fontSize: "14px",
            fontFamily: "Source Sans 3",
            padding: "5px !important",
        },
        "&.MuiFormControl-root": {
            paddingTop: "20px",
        },
    },
    // Modal (outlined) variant: match the height of the modal dropdowns (NewMainSelect).
    outlinedInput: {
        "& .MuiOutlinedInput-root": {
            height: theme.spacing(10.25),
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            background: theme.palette.secondary.main,
        },
    },
    tooltipDisplayNone: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            display: "none",
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: theme.spacing(1),
            wordBreak: "break-word",
        },
    },
}));
